/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CancellationTypeDTO = {
    Type1: 'Type1',
    Type3: 'Type3'
} as const;
export type CancellationTypeDTO = typeof CancellationTypeDTO[keyof typeof CancellationTypeDTO];

